// deno-lint-ignore-file no-explicit-any
export var OptionType;
(function(OptionType) {
  OptionType["STRING"] = "string";
  OptionType["NUMBER"] = "number";
  OptionType["INTEGER"] = "integer";
  OptionType["BOOLEAN"] = "boolean";
})(OptionType || (OptionType = {}));
//# sourceMappingURL=deprecated.js.map